import { apiClient, type Paginated } from '@/core/api';
import type { Commission, CommissionStatus, CommissionSummary } from './types';

export const BASE = '/finance/commissions/';

export interface CommissionListParams {
  page?: number;
  /** Filter to one employee (HR profile view). Finance roles only. */
  employee?: number;
  /** Filter to one salesperson (user id). */
  salesperson?: number;
  status?: CommissionStatus;
  deal?: number;
  ordering?: string;
}

export async function listCommissions(
  params: CommissionListParams = {},
): Promise<Paginated<Commission>> {
  const { data } = await apiClient.get<Paginated<Commission>>(BASE, { params });
  return data;
}

export async function getCommissionSummary(
  params: CommissionListParams = {},
): Promise<CommissionSummary> {
  const { data } = await apiClient.get<CommissionSummary>(`${BASE}summary/`, { params });
  return data;
}

export async function markCommissionPaidOut(publicId: string): Promise<Commission> {
  const { data } = await apiClient.post<Commission>(`${BASE}${publicId}/mark-paid-out/`);
  return data;
}

export async function voidCommission(publicId: string): Promise<Commission> {
  const { data } = await apiClient.post<Commission>(`${BASE}${publicId}/void/`);
  return data;
}

/** Hard-delete a commission (admin only, irreversible). */
export async function deleteCommission(publicId: string): Promise<void> {
  await apiClient.delete(`${BASE}${publicId}/`);
}
